import React from 'react';
import {
  GmailMail,
  ICloudMail,
  MailruMail,
  OutlookMail,
  RamblerMail,
  YandexMail,
} from '@lt/components/icons-react/auth';

import type { ProviderConfig } from './types';
import { EmailProvider } from './types';

export const mapProviderToConfig: Record<EmailProvider, ProviderConfig> = {
  [EmailProvider.Gmail]: {
    icon: <GmailMail width={25} height={25} />,
    name: 'Gmail',
    url: 'https://mail.google.com/',
  },
  [EmailProvider.Yandex]: {
    icon: <YandexMail width={25} height={25} />,
    name: 'Яндекс.Почту',
    url: 'https://mail.yandex.ru/',
  },
  [EmailProvider.Mail]: {
    icon: <MailruMail width={25} height={25} />,
    name: 'Почту Mail.ru',
    url: 'https://mail.ru/',
  },
  [EmailProvider.Rambler]: {
    icon: <RamblerMail width={25} height={25} />,
    name: 'Рамблер/почту',
    url: 'https://mail.rambler.ru/',
  },
  [EmailProvider.ICloud]: {
    icon: <ICloudMail width={25} height={25} />,
    name: 'iCloud',
    url: 'https://www.icloud.com/mail',
  },
  [EmailProvider.Outlook]: {
    icon: <OutlookMail width={25} height={25} />,
    name: 'Outlook',
    url: 'https://outlook.live.com/',
  },
};
